import { createSlice } from "@reduxjs/toolkit";
const name = "currentStudio";
const initialCurrentStudioData = {
  selectedStudio: null,
  daysOffToDelete: [],
  daysOffToPatch: [],
}

const currentStudioSlice = createSlice({
  name,
  initialState: {
    selectedStudioData: initialCurrentStudioData,
    updatingStatus: false,
  },
  reducers: {
    resetCurrentStudioData: (state) => {
      state.selectedStudioData = initialCurrentStudioData
    },
    setDaysOffToDelete: (state, action) => {
      state.selectedStudioData.daysOffToDelete = action.payload;
    },
    setDaysOffToPatch: (state, action) => {
      state.selectedStudioData.daysOffToPatch = action.payload;
    },
    setSelectedStudio: (state, action) => {
      state.selectedStudioData.selectedStudio = action.payload?.id;
    },

    updateScheduleData: (state, action) => {
      state.updatingStatus = true;
    },
    updateScheduleDataSuccess: (state) => {
      state.updatingStatus = false;
    },
    updateScheduleDataFailure: (state) => {
      state.updatingStatus = false;
    },
  },
});


export const {
  setDaysOffToDelete,
  setDaysOffToPatch,
  setSelectedStudio,
  resetCurrentStudioData,
  updateScheduleData,
  updateScheduleDataSuccess,
  updateScheduleDataFailure,
} = currentStudioSlice.actions;

export default currentStudioSlice.reducer;